<template>
	<entity-select-view class="employee-select-view" url="/employees/search/" :value="value" @input="$emit('input', $event)" :map="contactMap" :labelMap="contactLabel" :validator="contactValidator" :clearMap="clearContact" v-bind="$attrs" />
</template>

<script>
	import EntitySelectView from './EntitySelectView'

	export default {
		components: {
			'EntitySelectView': EntitySelectView
		},
		props: {
			value: {
				type: Object,
				default() {
					return {};
				}
			}
		},
		watch: {
			value(n, o) {
				
			}
		},
		methods: {
			contactMap(obj) {
				return {
					_embedded: {
						sender_employee: obj
					},
					sender_employee_id: obj.id
				};
			},
			contactLabel(obj) {
				obj = obj._embedded.sender_employee;

				

				return obj.name;
			},
			contactValidator(obj) {
				return obj.ssender_employee_id !== null;
			},
			clearContact(obj) {
				return {
					sender_employee_id: null
				};
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>